import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label, EmptyItem } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarCategoriaServicoDs,
  criarServicosIssDs,
} from "../../DataSources";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  categoriaId: undefined,
  descricao: "",
  lcFederal: undefined,
  lcMunicipal: undefined,
  aliquotaIss: undefined,
  aliquotaIrrfPj: undefined,
  aliquotaInssPj: undefined,
};

export default class ServicosIssForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.servicosIssDs = criarServicosIssDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.categoriaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarCategoriaServicoDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };

    this.localTributacaoOptions = {
      dataSource: [
        { id: true, descricao: "NO LOCAL DO SERVIÇO" },
        { id: false, descricao: "NA SEDE DO PRESTADOR" }
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.servicosIssDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("Serviço não encontrado.", "error");
              this.props.history.push("/servicosiss");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={1}>
            <GroupItem caption="SERVIÇOS" colSpan={1} colCount={3}>

              <SimpleItem dataField={"lcFederal"} colSpan={1} helpText={"Exemplos: 01.01, 07.01, 07.02."}>
                <Label text="LC Federal" />
              </SimpleItem>

              <SimpleItem dataField={"lcMunicipal"} colSpan={1}>
                <Label text="LC Municipal" />
              </SimpleItem>

              <SimpleItem dataField={"codigoRfb"} colSpan={1} helpText={"Exemplos: 010101, 070201, 070202."}>
                <Label text="Código RFB" />
              </SimpleItem>

              <SimpleItem
                dataField={"descricao"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "90px" }}
                colSpan={3}
              >
                <Label text="Descrição" />
              </SimpleItem>

              <SimpleItem
                dataField={"descricaoRfb"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "90px" }}
                colSpan={3}
              >
                <Label text="Descrição RFB" />
              </SimpleItem>

              <SimpleItem dataField={"aliquotaIss"} editorType={"dxNumberBox"} editorOptions={{ step: 0, format: uiInfo.formatoNumerico.n2 }} colSpan={1}>
                <Label text="Alíquota de ISS" />
              </SimpleItem>

              <EmptyItem colSpan={2} />

              <SimpleItem dataField={"aliquotaIrrfPj"} editorType={"dxNumberBox"} editorOptions={{ step: 0, format: uiInfo.formatoNumerico.n2 }} colSpan={1}>
                <Label text="Alíquota de IRRF PJ" />
              </SimpleItem>

              <EmptyItem colSpan={2} />

              <SimpleItem dataField={"aliquotaInssPj"} editorType={"dxNumberBox"} editorOptions={{ step: 0, format: uiInfo.formatoNumerico.n2 }} colSpan={1}>
                <Label text="Alíquota de INSS PJ" />
              </SimpleItem>

              <EmptyItem colSpan={2} />

              <SimpleItem
                dataField={"tributacaoNoLocalServico"}
                colSpan={3}
                editorType={"dxSelectBox"}
                editorOptions={this.localTributacaoOptions}
              >
                <Label text="Local de Tributação" />
              </SimpleItem>

              <SimpleItem
                dataField={"categoriaId"}
                colSpan={3}
                editorType={"dxLookup"}
                editorOptions={this.categoriaOptions}
              >
                <Label text="Categoria de Serviço" />
              </SimpleItem>

            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.servicosIssDs, entidade)
      .then(
        function () {
          notify("Responsável técnico cadastrada com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
